const state = {
  language: window.localStorage.getItem('language')
}

export default state